export function encodePassphrase(passphrase: string) {
  return encodeURIComponent(passphrase);
}

export function decodePassphrase(base64String: string) {
  return decodeURIComponent(base64String);
}

export function generateRoomId(): string {
  return `meeting-${randomString(16)}`;
}

export function randomString(length: number): string {
  let result = '';
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function isLowPowerDevice() {
  // 添加客户端检查，防止服务器端访问navigator对象
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false; // 默认返回false，避免在服务器端出错
  }
  return navigator.hardwareConcurrency < 6;
}
